import keyMirror from 'keymirror';

//Export orientation
const loose = 'loose';
const compact = 'compact';

//Export layout
const landscape = 'landscape';
const portrait = 'portrait';

//Export Page Size
const letter = 'letter';
const letterTitle = 'Letter (8.5" x 11")';
const legal = 'legal';
const legalTitle = 'Legal (8.5" x 14")';
const a4 = 'a4';
const a4Title = 'A4 (8.27" × 11.69")';
const a5 = 'a5';
const a5Title = 'A5 (5.83" x 8.27")';

const xls = 'xls';
const csv = 'csv';

export const PageSizes = {
  letter,
  letterTitle,
  legal,
  legalTitle,
  a4,
  a4Title,
  a5,
  a5Title,
};

export const PageFormats = keyMirror({
  Letter: null,
  Legal: null,
  Tabloid: null,
  Ledger: null,
  A0: null,
  A1: null,
  A2: null,
  A3: null,
  A4: null,
  A5: null,
  A6: null,
});

export const PageFormatTitles = {
  LetterTitle: letterTitle,
  LegalTitle: legalTitle,
  A4Title: a4Title,
  A5Title: a5Title,
};

export const RowSizes = keyMirror({
  Compact: null,
  Comfortable: null,
});

export const FileTypes = { xls, csv };
export const Orientation = { landscape, portrait };
export const LayoutSize = { loose, compact };
